import { useCallback, useEffect, useState } from "react";
import { listPages } from "../../../api/pagesApi";
import { listSections } from "../../../api/sectionsApi";
import { getApiErrorMessage } from "../../../api/unwrapApiResponse";

const GLOBAL_SLUG = "global";
const FOOTER_SECTION_KEY = "footer";

export function useFooterSectionAdmin({ skip = false } = {}) {
  const [sectionId, setSectionId] = useState(null);
  const [pageId, setPageId] = useState(null);
  const [pageName, setPageName] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [loading, setLoading] = useState(!skip);
  const [error, setError] = useState("");

  const resolve = useCallback(async () => {
    if (skip) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError("");
    try {
      const pages = await listPages();
      const list = Array.isArray(pages) ? pages : [];
      const globalPage =
        list.find((p) => (p.slug || "").toLowerCase() === GLOBAL_SLUG) ||
        list.find((p) => (p.name || "").toLowerCase().includes("global"));

      if (!globalPage) {
        setError(
          'No Global Layout page found. Create a page with slug "global" first.'
        );
        setSectionId(null);
        return;
      }

      const sections = await listSections(globalPage.id);
      const sectionList = Array.isArray(sections) ? sections : [];
      const footerSection =
        sectionList.find(
          (s) => (s.key || "").toLowerCase() === FOOTER_SECTION_KEY
        ) ||
        sectionList.find(
          (s) => (s.sectionType || "").toLowerCase() === "footer"
        );

      if (!footerSection) {
        setError(
          "No footer section found on the Global Layout page. Restart the backend to seed it."
        );
        setPageId(globalPage.id);
        setPageName(globalPage.name || "Global Layout");
        setSectionId(null);
        return;
      }

      setPageId(globalPage.id);
      setPageName(globalPage.name || "Global Layout");
      setSectionId(footerSection.id);
      setSectionName(footerSection.name || "Footer");
    } catch (err) {
      setError(getApiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }, [skip]);

  useEffect(() => {
    resolve();
  }, [resolve]);

  return {
    sectionId,
    pageId,
    pageName,
    sectionName,
    loading,
    error,
    reload: resolve,
  };
}
